<customer-edit-form [model]="model | async" (onSave)="saveCustomer($event)" [showAlert]="showAlert" (onGoToCust)="goToCustomer()"></customer-edit-form>
